import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';

// 取得.html檔中要渲染內容的DOM物件，不存在的話自己建一個div(for typescript check)
const tooltip = document.getElementById('tooltip');
const portalDiv = tooltip ? tooltip : document.createElement('div');

const Wrapper = styled.div`
  position: relative;
`;
const TipWrapper = styled.div<{ color?: string; top: number; left: number }>`
  position: absolute;
  background-color: ${(props) => (props.color ? props.color : colors.primaryBlue_400)};
  border-radius: 4px;
  padding: 12px 20px;
  color: ${colors.white};
  font-size: 15px;
  line-height: 1.5em;
  top: ${(props) => props.top + 'px'};
  left: ${(props) => props.left + 'px'};
  transform: translateX(-50%);
  word-break: break-word;
  max-width: 50%;

  &::after {
    position: absolute;
    border-style: solid;
    border-width: 8px;
    content: '';
    height: 0px;
    width: 0px;

    border-color: transparent transparent
      ${(props) => (props.color ? props.color : colors.primaryBlue_400)} transparent;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
  // 因與Banner通用參數，消除｜
  span {
    display: none;
  }
`;

interface IProps {
  className?: string;
  overlay: React.ReactNode;
  offset?: number;
  isHidden?: boolean; // 不顯示(使用)Tooltip的條件，可能是長度/字數小於多少或其他自訂條件
  children: React.ReactNode;
  bgColor?: string;
}

/**通用提示視窗 */
const Tooltip: React.FC<IProps> = (props) => {
  let [isShow, setIsShow] = useState<boolean>(false);
  let [left, setLeft] = useState<number>(0);
  let [top, setTop] = useState<number>(0);

  const handleMouseOver = (e: any) => {
    setIsShow(true);
    // currentTarget始終是事件監聽者，而target是事件的真正發出者。
    const pos = getPosition(e.currentTarget, props.offset);
    setLeft(pos.x);
    setTop(pos.y);
  };

  const handleMouseOut = () => {
    setIsShow(false);
  };

  return (
    <>
      {props.isHidden ? (
        <Wrapper>{props.children}</Wrapper>
      ) : (
        <Wrapper
          className={props.className}
          onMouseOver={(e) => handleMouseOver(e)}
          onMouseOut={() => handleMouseOut()}
        >
          {props.children}
          {isShow &&
            ReactDOM.createPortal(
              <TipWrapper top={top} left={left} color={props.bgColor}>
                {props.overlay}
              </TipWrapper>,
              portalDiv,
            )}
        </Wrapper>
      )}
    </>
  );
};

/** 取得Tooltip的顯示座標位置 */
function getPosition(element: any, customOffset?: number) {
  let x = 0;
  let y = 0;

  // 計算"Tooltip長方形邊界"到"hover元素邊界"的距離
  const defaultOffset = 8;
  const triangleWidth = 8;
  customOffset = customOffset ? customOffset : 0;
  const totalOffset = triangleWidth + defaultOffset + customOffset;

  // 取得元素長方形四個邊界在瀏覽器中的絕對位置、半長寬
  const rect = element.getBoundingClientRect();
  const rectHalfWidth = (rect.right - rect.left) / 2;

  x += rect.right - rectHalfWidth;
  y += rect.bottom + totalOffset + window.pageYOffset;

  return { x: x, y: y };
}

export default Tooltip;
